import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { computeHeightAndFontSize } from '@gift-variable-plugins/text-shared/textToFfCanvas';
import { ComputedValues, TextVariableInput } from '@gift-variable-plugins/text-shared/TextVariableInput';
import { editInput } from './editInput';
import { Direction } from './merge';

export const mergeTextIntoPrefab = (
    prefabInput: GiftJson.Input<TextVariableInput>,
    userInput: GiftJson.Input<TextVariableInput>,
    variable: GiftJson.Variable<any>,
    direction: Direction
): GiftJson.Input<TextVariableInput> => {

    const fromPrefab = prefabInput.value;
    const fromUser = userInput.value;

    const defaultContent = direction === 'inputIntoPrefab'
        ? fromPrefab.content
        : '';

    const maxLength = variable.options.maxLength;
    const content = fromUser.content && fromUser.content.length <= maxLength
        ? fromUser.content
        : defaultContent;

    return editInput(prefabInput, {

        content: content,
        fontFamily: fromUser.fontFamily || fromPrefab.fontFamily,

        // If the prefab has a non-default font style/weight, that's considered
        // a design feature that should be retained.

        fontStyle: fromUser.fontStyle === 'normal'
            ? fromUser.fontStyle || fromPrefab.fontStyle
            : fromUser.fontStyle,

        fontWeight: fromUser.fontWeight === 'normal'
            ? fromUser.fontWeight || fromPrefab.fontWeight
            : fromUser.fontWeight,

        ...computeTextMetrics(direction, fromUser, variable)
    });
};

const computeTextMetrics = (
    direction: Direction,
    fromUser: TextVariableInput,
    variable: GiftJson.Variable<any>
): ComputedValues | Record<never, never> => {

    if (direction === 'prefabIntoInput') {

        const { height, fontSize } = computeHeightAndFontSize(fromUser, variable);

        return {
            computedHeight: height,
            computedFontSize: fontSize
        };
    } else {
        return {};
    }
};